import React, { useCallback, useState } from "react";
import EventForm from "./ScheduleEventForm";
import { eventForm, IFacilityOption } from "./Types/calendarTypes";
import moment from "moment";
import { storeStateType, useAppDispatch } from "../../redux/store";
import {
  addNewEvent,
  editEvent,
  filterEventsType,
} from "../../redux/actions/schedule.actions";
import { IScheduleEvent } from "../../redux/reducers/schedule.reducer";

import { Dialog, DialogContent } from "@mui/material";
import { useSelector } from "react-redux";
import ModalBoxHeader from "../../components/ModalBoxHeader";

export type repeatEventType = {
  repeatOn: string;
  repeatDays: any[];
};

type AddCalendarEventPropsType = {
  showingEventForm: eventForm;
  setShowingEventForm: React.Dispatch<React.SetStateAction<eventForm>>;
  selectedEvent?: IScheduleEvent | null;
  overallDate?: string;
  selectedFacility: null | IFacilityOption;
  setSelectedEvent: React.Dispatch<React.SetStateAction<IScheduleEvent | null>>;
  titleName: string;
  filterEvents: filterEventsType;
};
export default function AddCalendarEventModal(
  props: AddCalendarEventPropsType
) {
  const dispatch = useAppDispatch();

  const {
    showingEventForm,
    setShowingEventForm,
    overallDate,
    selectedFacility,
    setSelectedEvent,
    titleName,
    filterEvents,
  } = props;
  const { latestSelectedEventData } = useSelector(
    (state: storeStateType) => state.schedule
  );
  const [repeatEvent, setRepeatEvent] = useState<repeatEventType>({
    repeatOn: "no-repeat",
    repeatDays: [],
  });

  function handleSubmit(data: any, isPublish: boolean) {
    let finalData = {
      ...data,
      sub_facility: data.sub_facility?.id ?? null,
      facility: data.facility.id,
    };
    let shiftDate = showingEventForm.preselectedDate; //selected date from header
    let momentObj = moment(showingEventForm.preselectedDate);
    finalData = { ...finalData, schedule_date: shiftDate };
    //for repeat of the event

    switch (repeatEvent.repeatOn) {
      case "repeat-tommorrow":
        let nextDate = momentObj.add(1, "days").format("YYYY-MM-DD");
        finalData = { ...finalData, other_schedule_dates: `${nextDate}` };
        break;
      case "repeat-rest-week":
        let nextDates = "";
        for (let i = 0; i < 7; i++) {
          nextDates = `${nextDates},${momentObj
            .add(1, "days")
            .format("YYYY-MM-DD")}`;
        }
        finalData = { ...finalData, other_schedule_dates: nextDates };
        break;
      case "repeat-specific-days":
        let offsetDay = momentObj.day(); //day number of week of choosen date
        let offDay = 0; //day number for indexing
        momentObj.subtract(offsetDay, "days"); //subtracting week day to first
        let repeatDaysList: number[] = repeatEvent.repeatDays.sort();
        let otherShiftDays: string[] = []; //array of shift days date

        //looping selected specific day number
        repeatDaysList.forEach((day) => {
          let shiftDate = momentObj
            .add(day - offDay, "days")
            .format(`YYYY-MM-DD`);
          //avoiding current day number
          if (!(offsetDay === day)) otherShiftDays.push(shiftDate);
          offDay = day;
        });

        finalData = {
          ...finalData,
          other_schedule_dates: otherShiftDays.join(","),
        };
        break;
      case "repeat-same-day":
        let repeatTimes: number = 0;
        if (repeatEvent?.repeatDays.length === 1) {
          repeatTimes = parseInt(repeatEvent?.repeatDays[0]);
        }

        let repeatDaysCopy = [];
        for (let i = 0; i < repeatTimes; i++) {
          repeatDaysCopy.push(finalData.schedule_date);
        }
        finalData = {
          ...finalData,
          other_schedule_dates: repeatDaysCopy.join(","),
        };
        break;
      default:
        break;
    }

    const formData = new FormData();
    formData.append("facility", finalData.facility);
    formData.append("work_type", finalData.work_type);
    formData.append("schedule_date", finalData.schedule_date);
    formData.append("start_time", finalData.start_time);
    formData.append("end_time", finalData.end_time);
    formData.append("schedule_status", finalData.schedule_status);
    if (finalData.schedule_note) {
      formData.append("schedule_note", finalData.schedule_note);
    }
    if (finalData.sub_facility) {
      formData.append("sub_facility", finalData.sub_facility);
    }
    if (finalData.other_schedule_dates) {
      formData.append("other_schedule_dates", finalData.other_schedule_dates);
    }
    if (isPublish) {
      formData.append("publish", "true");
    }
    if (!isPublish) {
      formData.append("publish", "false");
    }
    dispatch(addNewEvent(formData, filterEvents));
  }

  function handleEditSubmit(data: any, isPublish: boolean) {
    let finalData = {
      ...data,
      id: latestSelectedEventData?.id,
      facility: data.facility?.id,
      sub_facility: data?.sub_facility?.id ?? null,
      schedule_date: latestSelectedEventData?.schedule_date,
    };
    let momentObj = moment(latestSelectedEventData?.schedule_date);

    //for repeat of the event
    switch (repeatEvent.repeatOn) {
      case "repeat-tommorrow":
        let nextDate = momentObj.add(1, "days").format("YYYY-MM-DD");
        finalData = { ...finalData, other_schedule_dates: `${nextDate}` };
        break;

      case "repeat-rest-week":
        let nextDates = "";
        for (let i = 0; i < 7; i++) {
          nextDates = `${nextDates},${momentObj
            .add(1, "days")
            .format("YYYY-MM-DD")}`;
        }
        finalData = { ...finalData, other_schedule_dates: nextDates };
        break;

      case "repeat-specific-days":
        let offsetDay = momentObj.day(); //day number of week of choosen date
        let offDay = 0; //day number for indexing
        momentObj.subtract(offsetDay, "days"); //subtracting week day to first
        let repeatDaysList: number[] = repeatEvent.repeatDays.sort();
        let otherShiftDays: string[] = []; //array of shift days date

        //looping selected specific day number
        repeatDaysList.forEach((day) => {
          let shiftDate = momentObj
            .add(day - offDay, "days")
            .format(`YYYY-MM-DD`);
          //avoiding current day number
          if (!(offsetDay === day)) otherShiftDays.push(shiftDate);
          offDay = day;
        });

        finalData = {
          ...finalData,
          other_schedule_dates: otherShiftDays.join(","),
        };
        break;
      case "repeat-same-day":
        let repeatTimes: number = 0;
        if (repeatEvent?.repeatDays.length === 1) {
          repeatTimes = parseInt(repeatEvent?.repeatDays[0]);
        }
        let repeatDaysCopy = [];
        for (let i = 0; i < repeatTimes; i++) {
          repeatDaysCopy.push(finalData.schedule_date);
        }
        finalData = {
          ...finalData,
          other_schedule_dates: repeatDaysCopy.join(","),
        };
        break;
      default:
        break;
    }
    const formData = new FormData();
    formData.append("facility", finalData.facility);
    formData.append("work_type", finalData?.work_type);
    formData.append("schedule_date", finalData.schedule_date);
    formData.append("start_time", finalData.start_time);
    formData.append("end_time", finalData.end_time);
    formData.append("schedule_status", finalData.schedule_status);
    if (finalData.schedule_note) {
      formData.append("schedule_note", finalData.schedule_note);
    }
    if (finalData.sub_facility) {
      formData.append("sub_facility", finalData.sub_facility);
    }
    if (finalData.other_schedule_dates) {
      formData.append("other_schedule_dates", finalData.other_schedule_dates);
    }
    if (isPublish) {
      formData.append("publish", "true");
    }
    if (!isPublish) {
      formData.append("publish", "false");
    }
    dispatch(editEvent(finalData.id, formData));
  }

  const handleModalClose = useCallback(() => {
    setShowingEventForm({ visible: false });
    setSelectedEvent(null);
  }, [setShowingEventForm, setSelectedEvent]);
  return (
    <Dialog open={true} sx={{ width: "100vw" }}>
      <ModalBoxHeader
        title={
          latestSelectedEventData ? `Edit ${titleName}` : `Add ${titleName}`
        }
        handleClose={handleModalClose}
      />

      <DialogContent>
        <EventForm
          handleSubmit={
            latestSelectedEventData ? handleEditSubmit : handleSubmit
          }
          handleClose={handleModalClose}
          overallDate={overallDate}
          selectedFacility={selectedFacility}
          showingEventForm={showingEventForm}
          setRepeatEvent={setRepeatEvent}
          repeatEvent={repeatEvent}
        />
      </DialogContent>
    </Dialog>
  );
}
//   return (
//     <Modal
//       open={true}
//       onClose={handleModalClose}
//       className="modal-container"
//       aria-labelledby="modal-modal-title"
//       aria-describedby="modal-modal-description"
//     >
//       <Box className="rostme-modal">
//         <Box
//           className="modal-header"
//           display="flex"
//           alignItems="center"
//           justifyContent="space-between"
//         >
//           <h3 style={{ textAlign: "center" }}>Schedule Form</h3>
//           <CloseIcon
//             onClick={handleModalClose}
//             sx={{ marginRight: "1rem", cursor: "pointer" }}
//           />
//         </Box>
//         <hr />
//         <Box className="modal-body">
//           <EventForm
//             handleSubmit={latestSelectedEventData ? handleEditSubmit : handleSubmit}
//             editEvent={selectedEvent}
//             handleClose={handleModalClose}
//             overallDate={overallDate}
//             selectedFacility={selectedFacility}
//             showingEventForm={showingEventForm}
//             setRepeatEvent={setRepeatEvent}
//             repeatEvent={repeatEvent}
//           />
//         </Box>
//       </Box>
//     </Modal>
//   );
// }
